/**
 * Configuration du client HTTP.
 *
 * Isolée du client lui-même pour que la couche session (qui doit émettre des
 * requêtes SANS l'intercepteur d'authentification) puisse la réutiliser sans
 * créer d'import circulaire.
 */

/** Origine de l'API. Les chemins portent déjà le préfixe de version `/api/v1`. */
export const API_BASE_URL: string = import.meta.env["VITE_API_BASE_URL"] ?? "";

/**
 * Exigé par les endpoints à cookie : impossible à poser depuis un formulaire
 * cross-origin sans préflight, ce qui limite la surface CSRF (docs/20 §5).
 */
export const DEFAULT_HEADERS = {
  "X-Requested-With": "XMLHttpRequest",
} as const;
